import { Autocomplete, InputAdornment, TextField } from "@mui/material";
import { Box, Grid } from "@mui/system";
import SearchIcon from "@mui/icons-material/Search";
import PairAddRecordsFilterObjs from "./PairAddRecordsFilterObjs";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { setFMEIdPair } from "../../../../../../../features/financeReceiptSlice";
import { useSearchParams } from "react-router-dom";

const PairAddRecordsFilter = () => {
  const { normalizedFinancialMonthlyEarningsData, FMEIdPair } = useSelector(
    (state: any) => state.receipts
  );
  const [, setSearchParams] = useSearchParams();
  const dispatch = useDispatch();
  const fmeOptions = (normalizedFinancialMonthlyEarningsData || []).map(
    (item: any) => ({
      label: String(item.id), // what user sees
      value: item.id, // actual value
    })
  );

  const selectedOption =
    fmeOptions.find((opt: any) => opt.value === FMEIdPair) || null;

  return (
    <>
      <Box sx={{ padding: "20px 16px 0px 16px !important" }}>
        <Grid container rowSpacing={6} columnSpacing={3} alignItems={"center"}>
          <Grid size={3}>
            <Autocomplete
              data-tracker="589"
              sx={{ width: "100%" }}
              value={selectedOption}
              options={fmeOptions}
              onChange={(_, newValue) => {
                const fmeId = newValue ? newValue.value : null;
                dispatch(setFMEIdPair(fmeId));
                setSearchParams((prevParams) => {
                  const updatedParams = Object.fromEntries(prevParams);
                  if (fmeId) {
                    updatedParams.fme = String(fmeId);
                  } else {
                    delete updatedParams.fme;
                  }
                  return updatedParams;
                });
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="FME"
                  value={""}
                  // sx={{ width: "300px" }}
                  InputProps={{
                    ...params.InputProps,
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon sx={{ marginLeft: "12px" }} />
                      </InputAdornment>
                    ),
                  }}
                  color="secondary"
                />
              )}
              size="small"
            />
          </Grid>
          <Grid size={7} data-tracker="590">
            <PairAddRecordsFilterObjs />
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

export default PairAddRecordsFilter;
